import * as React from "react";
import { AWSSummary } from "./cloudAccessSummary/awsSummary";
import { AzureSummary } from "./cloudAccessSummary/azureSummary";
import { GCPSummary } from "./cloudAccessSummary/gcpSummary";
import { NGSSummary } from "./cloudAccessSummary/ngsSummary";

export const CloudAccessOverview: React.FC = () => {
  return (
    <div style={{ minWidth: 600, maxWidth: 1600, width: "100%" }}>
      <div className="mb-6">
        <AWSSummary />
      </div>
      <div className="mb-6">
        <AzureSummary />
      </div>
      <div className="mb-6">
        <GCPSummary />
      </div>
      <div className="mb-6">
        <NGSSummary />
      </div>
    </div>
  );
};
